import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { ValueAccessorProviderFactory } from '../value-accessor/value-accessor-provider-factory';
import { RadioGroupComponent } from '../radio/radio-group.component';

@Component({
  selector: 'td-wb-toggle-label',
  templateUrl: './toggle-label.component.html',
  styleUrls: ['./toggle-label.component.scss'],
  providers: [ValueAccessorProviderFactory(ToggleLabelComponent)],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule
  ]
})
export class ToggleLabelComponent extends RadioGroupComponent {
  readonly disabled: InputSignal<boolean> = input<boolean>(false);
  readonly readonly: InputSignal<boolean> = input<boolean>(false);
  readonly outline: InputSignal<boolean> = input<boolean>(false);
  readonly whiteBackground: InputSignal<boolean> = input<boolean>(false);

  override writeValue(value: unknown): void {
    if ((value ?? null) !== null) {
      super.writeValue(value);
    }
  }
}
